import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { ModelTrainProps } from '../../../types/reduxTypes/modelTrain';

const createReducer = <T extends SliceCaseReducers<ModelTrainProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setModelTrainData(state, action) {
    state.modelTrainData = action.payload;
  }
});

export default reducers;
